/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GenericEvent } from "./GenericEvent";
export const Event = core.serialization
    .union("topic", {
    "agent:created": GenericEvent,
    "agent:updated": GenericEvent,
    "agent:deleted": GenericEvent,
    "space:created": GenericEvent,
    "space:updated": GenericEvent,
    "space:deleted": GenericEvent,
    "space:archived": GenericEvent,
    "space:expired": GenericEvent,
    "space:guestAdded": GenericEvent,
    "space:guestRemoved": GenericEvent,
    "document:created": GenericEvent,
    "document:updated": GenericEvent,
    "document:deleted": GenericEvent,
    "workbook:created": GenericEvent,
    "workbook:updated": GenericEvent,
    "workbook:deleted": GenericEvent,
    "workbook:expired": GenericEvent,
    "workbook:thawed": GenericEvent,
    "flag:created": GenericEvent,
    "flag:updated": GenericEvent,
    "flag:deleted": GenericEvent,
    "sheet:created": GenericEvent,
    "sheet:updated": GenericEvent,
    "sheet:deleted": GenericEvent,
    "sheet:counts-updated": GenericEvent,
    "sheet:calculation-updated": GenericEvent,
    "snapshot:created": GenericEvent,
    "records:created": GenericEvent,
    "records:updated": GenericEvent,
    "records:deleted": GenericEvent,
    "file:created": GenericEvent,
    "file:updated": GenericEvent,
    "file:deleted": GenericEvent,
    "file:expired": GenericEvent,
    "job:created": GenericEvent,
    "job:updated": GenericEvent,
    "job:deleted": GenericEvent,
    "job:failed": GenericEvent,
    "job:completed": GenericEvent,
    "job:ready": GenericEvent,
    "job:scheduled": GenericEvent,
    "job:outcome-acknowledged": GenericEvent,
    "job:parts-completed": GenericEvent,
    "program:created": GenericEvent,
    "program:updated": GenericEvent,
    "commit:created": GenericEvent,
    "commit:updated": GenericEvent,
    "commit:completed": GenericEvent,
    "secret:created": GenericEvent,
    "secret:updated": GenericEvent,
    "secret:deleted": GenericEvent,
    "layer:created": GenericEvent,
    "environment:created": GenericEvent,
    "environment:updated": GenericEvent,
    "environment:deleted": GenericEvent,
    "environment:autobuild-created": GenericEvent,
    "action:created": GenericEvent,
    "action:updated": GenericEvent,
    "action:deleted": GenericEvent,
    "data-clip:created": GenericEvent,
    "data-clip:updated": GenericEvent,
    "data-clip:deleted": GenericEvent,
    "data-clip:collaborator-updated": GenericEvent,
    "data-clip:resolutions-created": GenericEvent,
    "data-clip:resolutions-updated": GenericEvent,
    "data-clip:resolutions-refreshed": GenericEvent,
    "canvas:created": GenericEvent,
    "canvas:updated": GenericEvent,
    "canvas:deleted": GenericEvent,
    "canvas-area:created": GenericEvent,
    "canvas-area:updated": GenericEvent,
    "canvas-area:deleted": GenericEvent,
})
    .transform({
    transform: (value) => value,
    untransform: (value) => value,
});
